/**
 * Professions Module
 */
import Vue from 'vue';
import router from '../../../router/router';
import { apiModel, makeApiRequest } from "../../../api";
import {store} from "../../store";
import AppConfig from "../../../constants/AppConfig";

// States
const state = {
    medicalAdvice: {},
    medicalAdvices: [],
    patientAdvices: [],
};

// Getters
const getters = {
    medicalAdvice: state => {
        return state.medicalAdvice
    },

    medicalAdvices: state => {
        return state.medicalAdvices
    },

    patientAdvices: state => {
        return state.patientAdvices
    }
};

// Actions
const actions = {
    getMedicalAdvices(context, payload) {
        function successCallback(response) {
            context.commit('getMedicalAdvicesHandler', { medicalAdvices: response.data.avis });
        }

        function errorCallback(error) {
            // Vue.swal(
            //     payload.errorMessages.error,
            //     '',
            //     'error'
            // );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.MedicalAdvice.List, localToken, successCallback, errorCallback, payload.errorMessages);
    },
    
    getMedicalAdvicesPatient(context, payload) {
        function successCallback(response) {
            context.commit('getMedicalAdvicesPatientHandler', { patientAdvices: response.data.avis });
        }

        function errorCallback(error) {

        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.MedicalAdvice.Patient, localToken, successCallback, errorCallback, payload.errorMessages);
    },
    getMedicalAdvice(context, payload) {
        function successCallback(response) {
            context.commit('getMedicalAdviceHandler', { medicalAdvice: response.data.avis });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.MedicalAdvice.Get, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    createMedicalAdvice(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );

            // Here we add a follow-up to the list of follow-ups
            context.commit('pushMedicalAdviceHandler', { medicalAdvice: response.data.medicalAdvice });


            // we can leave to the route of a tracking display
            // We assume that if there's a view to display a tracker or followed-up, that we call it suivi
            // router.push({ name: 'suivi', params: { suivi: response.data.suivi.slug } });
            router.push({ name: 'medical-advice' });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.MedicalAdvice.Create, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    updateMedicalAdvice(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );

            // store.dispatch('findAndRemove', {name: 'suivi' });

            //We assume that if there's a view to display a tracker
            //or followed-up, that we call it suivi

            router.push({ name: 'medical-advice' });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        const url = AppConfig.apiUrl + apiModel.MedicalAdvice.Create.url + '/' + payload.slug;

        Vue.axios.put(
            url,
            payload.args,
            {
                headers: {
                    'Authorization': `Bearer ${localToken}`,
                    // 'Content-Type': 'multipart/form-data'
                }
            }
        )
        .then(successCallback)
        .catch(errorCallback);

        //makeApiRequest(payload.args, apiModel.Followed.Update, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    deleteMedicalAdvice(context, payload) {
        function successCallback(response) {
            context.commit('deleteMedicalAdviceHandler', { index: payload.index, successMessage: payload.successMessage });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        const url = AppConfig.apiUrl + apiModel.MedicalAdvice.Create.url + '/' + payload.slug;

        Vue.axios.delete(
            url,
            {
                headers: {
                    'Authorization': `Bearer ${localToken}`,
                    // 'Content-Type': 'multipart/form-data'
                }
            }
        )
        .then(successCallback)
        .catch(errorCallback);

        // makeApiRequest(payload.args, apiModel.Followed.Delete, localToken, successCallback, errorCallback, payload.errorMessages);
    },
};

// Mutations
const mutations = {
    getMedicalAdviceHandler(state, { medicalAdvice }) {
        // Update followed state
        state.medicalAdvice = medicalAdvice;
    },

    getMedicalAdvicesHandler(state, { medicalAdvices }) {
        // Update followed state
        state.medicalAdvices = medicalAdvices;
    },
    getMedicalAdvicesPatientHandler(state, { patientAdvices }) {
        // Update followed state
        state.patientAdvices = patientAdvices;
    },

    pushMedicalAdviceHandler(state, { medicalAdvice }) {
        // Update followed state
        state.medicalAdvices.push(medicalAdvice);
    },

    deleteMedicalAdviceHandler(state, { index, successMessage }) {
        let i = state.medicalAdvices.findIndex(medicalAdvice => medicalAdvice.slug === index);

        if (~i) {
            state.medicalAdvices.splice(i, 1);

            // After deleting from the list of follow-ups you can go to the listing route
            // if you wish. Please note that if we are on the follow-ups listing page,
            // the list of follow-ups is already updated as of this date.

            //We assume that if there is a view to display the
            // follow-ups, that we call it follow-ups
            router.push({ name: 'medical-advice' });

            Vue.swal(
                successMessage,
                '',
                'success'
            );
        }
    },
};

export default {
    state,
    getters,
    actions,
    mutations
}
